var _defs, _path, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-eu",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "eu-d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eu-b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eu-a",
    d: "m0-1-.3 1 .5.1z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eu-a",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eu-c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eu-b",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eu-b",
    transform: "rotate(144)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eu-c",
    transform: "scale(-1 1)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "M0 0h640v480H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0",
    transform: "translate(320 242.3)scale(23.7037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eu-d",
    width: "100%",
    height: "100%",
    y: -6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eu-d",
    width: "100%",
    height: "100%",
    y: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "eu-e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eu-d",
    width: "100%",
    height: "100%",
    x: -6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eu-d",
    width: "100%",
    height: "100%",
    transform: "rotate(-144 -2.3 -2.1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eu-d",
    width: "100%",
    height: "100%",
    transform: "rotate(144 -2.1 -2.3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eu-d",
    width: "100%",
    height: "100%",
    transform: "rotate(72 -4.7 -2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eu-d",
    width: "100%",
    height: "100%",
    transform: "rotate(72 -5 .5)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eu-e",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/eu.c9d8d63e107e62b812c8cb4eaffb5da5.svg";
export { ForwardRef as ReactComponent };